import react, { useEffect, useState } from 'react'

import {
    CCard,
    CCardBody,
    CCardTitle,
    CCardSubtitle,
    CCol,
    CRow,
    CCardText
} from '@coreui/react'
import CookieFunctions from '../functions/CookieFunctions'
import { toast } from 'react-toastify'
import SafetyMessage from '../components/safety/SafetyMessage'

export default function Home() {
    var firstName = CookieFunctions.getFirstName()
    var lastName = CookieFunctions.getLastName()

    const [messages, setMessages] = useState([])

    function getActiveMessages() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/drivers/messages/getActive",
            {
                headers: myHeaders,
                method: 'GET'
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            setMessages(data)
        }).catch((e) => {
            toast.error(e, {
                closeButton: true,
                autoClose: true,
                position: toast.POSITION.BOTTOM_CENTER,
                theme: "colored",
            })
        })
    }

    useEffect(() => {
        getActiveMessages()
    }, [])

    return (
        <CRow>
            <CCol xs={12} md={8} >
                <CCard className="mb-4">
                    <CCardBody>
                        <CCardTitle className='fs-2'>Welcome, {firstName} {lastName} to the Titanium Driver Portal</CCardTitle>
                        <CCardText className='fs-5'>On this page you can book time off, see your personal documents, and find links to common driver websites. Below you will find some simple instructions.</CCardText>
                        <CCardText className='fs-5 fw-bold'>Time Off Summary</CCardText>
                        <CCardText>
                            <p>To see the current balance of your time-off requests, click on “Summary” from the left side of the screen. Once in the Summary screen, you can choose a time-off type to view its summary. You can also see a list of all your past requests.</p>
                        </CCardText>
                        <CCardText className='fs-5 fw-bold'>Requesting Time Off</CCardText>
                        <CCardText>
                            <p>To request time off, start by clicking on “Request Time Off” from the left side of the screen. You can then submit a request by doing the following</p>
                            <ol>
                                <li>Select the time-off type</li>
                                <li>Enter the start and end dates that you want to take off.</li>
                                <li>Enter any special comments. This is optional.</li>
                                <li>When you have filled out all the fields, click the Submit button. This will send your request to your dispatcher.</li>
                                <li>Your dispatcher will review your request and either approve or decline it. You will get an email with their response. You can also log into the portal and go to the Summary page, to see your dispatchers response.</li>
                            </ol>
                        </CCardText>
                        <CCardText className='fs-5 fw-bold'>Cancelling a Request</CCardText>
                        <CCardText>
                            <p>To cancel a request, go to your Summary on the left side of the screen and click the red "X" button beside the request you want to cancel.</p>
                            <ul>
                                <li>All "Pending Approval" requests will be cancelled instantly and </li>
                                <li>All other cancel requests will be sent to dispatcher for approval</li>
                            </ul>
                            <p>*Note: You may only cancel requests set for days in the future. For all other questions, please refer to the "Need Help?" section for who to contact</p>
                        </CCardText>
                        <CCardText className='fs-5 fw-bold'>Documents</CCardText>
                        <CCardText>
                            <p>You can find all your documents by clicking on “Documents” from the left side of the screen. This will show you a list of document types. Click on the document type to see that specific type, or select “All” to see all document types.

                                <br /><br />Once you’re selected your document type, you can narrow your search by clicking on the date range options at the top of the screen.
                            </p>
                        </CCardText>
                        <CCardText className='fs-5 fw-bold'>Useful Links</CCardText>
                        <CCardText>
                            <p>You can find helpful links to websites under the Useful Links section in the menu on the left side of the screen.</p>
                        </CCardText>
                        <CCardText className='fs-5 fw-bold'>Logging Out</CCardText>
                        <CCardText>
                            <p>To log out of the portal, click on the picture of the head side your name at the top right of the screen. Then choose “Logout”.</p>
                        </CCardText>
                        <CCardText className='fs-5 fw-bold'>Need Help?</CCardText>
                        <CRow>
                            <CCol sm="5">
                                <CCardText>For any questions about time-off:</CCardText>
                                <CCardText>
                                    Joanna Lam <br />
                                    hr@ttgi.com <br />
                                    905-266-3076
                                </CCardText>
                            </CCol>
                            <CCol sm="5" >
                                <CCardText>For any questions about pay:</CCardText>
                                <CCardText>
                                    Dhaily Hayward <br />
                                    payroll@ttgi.com <br />
                                    905-266-3052
                                </CCardText>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard >
            </CCol>
            <CCol xs={12} md={4} >
                <CCard>
                    <CCardBody>
                        <CCardTitle className='fs-2'>Messages</CCardTitle>
                        <CCardText>
                            <SafetyMessage messages={messages} />
                        </CCardText>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

    )
}